const getRandomIndex = (length: number) => (length > 0 ? Math.floor(Math.random() * length) : 0);

export default getRandomIndex;
